import React from "react";
import Image from "next/image";
import Link from "next/link";
import CollapseItem from "./CollapseItem.js";
import { Icon } from "../../icons/icons.js";
import { useTranslation } from "../../context/TranslationContext.js";

const Faq = ({ data, isHome = 0 }) => {
  const { showAll, faqTitle, instagramSubtitle, instagramText, instagramFollow } =
    useTranslation();
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleToggle = (index) => {
    if (activeIndex === index) return;
    setActiveIndex(-1);
    setTimeout(() => {
      setActiveIndex(index);
    }, 200);
  };



  // Helper for Instagram SVG (Solid Color or CurrentColor)
  const InstagramSimple = ({ className }) => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );

  return (
    <section className={`py-12 bg-gray-50 ${isHome ? "relative" : ""}`}>
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 md:mb-12">
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              {faqTitle}
            </h3>
          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Left Column: FAQ Items */}
          <div className="lg:col-span-8 space-y-4">
            {data &&
              data.data.map((v, i) => (
                <CollapseItem
                  key={i}
                  title={v.baslik}
                  description={v.icerik}
                  isOpen={activeIndex === i}
                  toggle={() => handleToggle(i)}
                />
              ))}


          </div>

          {/* Right Column: Social Proof (Desktop & Mobile) */}
          <div className="flex lg:col-span-4 flex-col gap-6 mt-8 lg:mt-0 lg:sticky lg:top-24 lg:self-start">
            {/* Instagram Card - Corporate Profile Style */}
            <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-6 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 rounded-full p-[2px] bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 flex-shrink-0">
                  <div className="w-full h-full rounded-full border-2 border-white overflow-hidden bg-gray-50">
                    <div className="w-full h-full flex items-center justify-center bg-white">
                      {/* Using Simple Instagram Icon with brand color */}
                      <InstagramSimple className="w-6 h-6 text-[#E1306C]" />
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">
                    @villavillam.com.tr
                  </h4>
                  <p className="text-xs text-gray-500">
                    {instagramSubtitle}
                  </p>
                </div>
              </div>

              <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                {instagramText}
              </p>

              <a
                href="https://www.instagram.com/villavillam.com.tr/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full py-2.5 text-white font-semibold text-sm rounded bg-gradient-to-r from-purple-500 to-pink-500 hover:opacity-90 transition-opacity shadow-sm"
              >
                {/* White Icon for Button */}
                <InstagramSimple className="w-4 h-4 text-white" />
                {instagramFollow}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Faq;
